import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import { useAsyncEffect } from 'customHooks/hooks';
import React, { ReactElement, useContext } from 'react';
import { WidgetGeneratorContext } from 'screens/WidgetGenerator/contexts/WidgetGeneratorContext';
import { getOverallSatisfcationWidgetData } from 'screens/WidgetGenerator/helpers/overallScore';
import { DEFAULT_DATA } from 'screens/WidgetGenerator/utils/defaultValues';
import { ScoreTextWithSentimentBarWidgetData, WidgetType } from 'screens/WidgetGenerator/utils/misc';
import { ScoreTextWithSentimentBar } from 'screens/WidgetGenerator/widgets/ScoreTextWithSentimentBar/ScoreTextWithSentimentBar';
import { logger } from 'utils/logger';

const DEFAULT_OVERALL_SATISFACTION_DATA: ScoreTextWithSentimentBarWidgetData[] = [
  {
    score: JSON.parse(DEFAULT_DATA[WidgetType.OVERALL_SATISFACTION_TEXT]),
    text: '',
    emphasizedText: '',
  },
];

export const OverallSatisfactionTextHOC = (): ReactElement => {
  const { client, cycles, selectedDateRange } = useContext(WidgetGeneratorContext);

  const fetchOverallSatisfactionWidgetData = async () => {
    const overallSatisfcationData = await getOverallSatisfcationWidgetData(client, cycles, selectedDateRange);
    return overallSatisfcationData;
  };

  const {
    fetchedData: overallSatisfactionData,
    isLoading,
    error,
  } = useAsyncEffect(fetchOverallSatisfactionWidgetData, [client, cycles, selectedDateRange]);

  if (error) {
    logger.error(error);
  }

  return (
    <LoaderMask isLoading={isLoading}>
      <ScoreTextWithSentimentBar
        widgetData={overallSatisfactionData ?? DEFAULT_OVERALL_SATISFACTION_DATA}
        isBenchmarked
      />
    </LoaderMask>
  );
};
